import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customPathInput", "redirectFields", "fromPathInput", "toPathInput"];

  updateRedirects() {
    if (!this.hasCustomPathInputTarget) return;

    const customPathInput = this.customPathInputTarget;
    const rawPath = customPathInput.value?.trim();
    const { pagePath, pageUrl } = customPathInput?.dataset || {};
    const hiddenToPathInputs = this.toPathInputTargets;

    if (!rawPath && !pagePath) {
      hiddenToPathInputs.forEach(input => {
        input.value = pageUrl;
      });
      return;
    }

    const normalizedPath = rawPath?.startsWith("/") ? rawPath : `/${rawPath}`;

    hiddenToPathInputs.forEach(input => {
      const base = input.defaultValue.replace(/\/[^/]*$/, "");
      input.value = base + normalizedPath;
    });
  }

  updateRedirectsOnAdd() {
    setTimeout(() => { this.updateRedirects() }, 0)
  }

  resetFromPathNotDeleted() {
    if (!this.hasRedirectFieldsTarget) return;

    this.fromPathInputTargets.forEach(input => {
      const originalValue = input.dataset.originalValue;
      if (input.value.trim() === "" && originalValue) {
        input.value = originalValue;
      }
    });
  }
}
